import React from 'react';
import '../stylesheets/account.scss';



class ProfileList extends React.Component {
  render() {
    let data = this.props.data;
    let clicked = this.props.clicked;

    return (
      <li 
      className={
          clicked === data.dataValue
            ? 'list-item list-item-clicked'
            : 'list-item'
        }
        data-value={data.dataValue}
        onClick={this.props.onClick}
      >
        <div className='list-item-description'>
          <h2>{data.key}</h2>
          <i>{data.icon}</i>
        </div>
        <h5 className='description-text-clear'>{data.item}</h5>

      </li>
    );
  }
};

export default ProfileList;